import React from 'react';
import { motion } from 'framer-motion';
export function EditorialSplit() {
  return <section className="w-full flex flex-col" data-id="element-30">
      {/* Block A */}
      <div className="flex flex-col md:flex-row w-full min-h-[70vh] bg-cream" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        x: -80
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 1.2,
        ease: [0.2, 0.65, 0.3, 0.9]
      }} className="w-full md:w-1/2 h-[50vh] md:h-auto" data-id="element-32">
          <img src="https://cdn.magicpatterns.com/uploads/oLwzGvzAXBfZ69Suwqk4JX/imagen_9.webp" alt="Arreglo floral artesanal" className="w-full h-full object-cover" data-id="element-33" />
        </motion.div>
        <div className="w-full md:w-1/2 flex items-center justify-center p-12 md:p-24 lg:p-32" data-id="element-34">
          <motion.div initial={{
          opacity: 0,
          y: 60
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 1.2,
          delay: 0.2,
          ease: [0.2, 0.65, 0.3, 0.9]
        }} data-id="element-35">
            <h2 className="text-4xl md:text-5xl text-forest mb-8 italic" data-id="element-36">
              Diseño Artesanal
            </h2>
            <p className="text-lg md:text-xl text-forest/80 leading-relaxed" data-id="element-37">
              Trabajamos con flores de temporada, seleccionadas meticulosamente
              para crear diseños únicos. No creemos en catálogos estáticos; cada
              composición nace de la inspiración del momento y la frescura de la
              naturaleza, asegurando que tu arreglo sea verdaderamente
              irrepetible.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Block B */}
      <div className="flex flex-col-reverse md:flex-row w-full min-h-[70vh] bg-forest" data-id="element-38">
        <div className="w-full md:w-1/2 flex items-center justify-center p-12 md:p-24 lg:p-32" data-id="element-39">
          <motion.div initial={{
          opacity: 0,
          y: 60
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 1.2,
          delay: 0.2,
          ease: [0.2, 0.65, 0.3, 0.9]
        }} data-id="element-40">
            <h2 className="text-4xl md:text-5xl text-cream mb-8 italic" data-id="element-41">
              La Emoción del Detalle
            </h2>
            <p className="text-lg md:text-xl text-cream/80 leading-relaxed" data-id="element-42">
              Recibir flores es una experiencia visceral. Nos enfocamos en la
              emoción detrás de cada ramo: la sorpresa, el aroma que inunda la
              habitación, y la belleza visual que transforma un día ordinario en
              una celebración extraordinaria.
            </p>
          </motion.div>
        </div>
        <motion.div initial={{
        opacity: 0,
        x: 80
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 1.2,
        ease: [0.2, 0.65, 0.3, 0.9]
      }} className="w-full md:w-1/2 h-[50vh] md:h-auto" data-id="element-43">
          <img src="https://cdn.magicpatterns.com/uploads/7LqfsHsTuUdCnKPLjotwJq/imagen_10.webp" alt="Ramo de flores vibrantes" className="w-full h-full object-cover" data-id="element-44" />
        </motion.div>
      </div>
    </section>;
}